<template>
  <div>
    <span>{{ t("components.eventAction.filter.ui.RecentlyChanged.text") }}</span>
    <div class="flex flex-auto">
      <LISAInputNumber v-model.number="numberOfHours" style="font-size: inherit" />

      <PrimeVueSelect
        v-model.number="timeMultiplier"
        :options="multiplierOptions"
        option-label="text"
        class="w-100"
        option-value="value"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import PrimeVueSelect from "primevue/select";
import { computed, ref } from "vue";
import { useTranslation } from "@/language/translation";
import RecentlyChangedFilter from "../filterImplementations/RecentlyChangedFilter";
import LISAInputNumber from "@/components/primevueWrapper/LISAInputNumber.vue";

defineOptions({
  inheritAttrs: false,
});
const { t } = useTranslation();
const numberOfHours = ref(1);
const timeMultiplier = ref<1 | 24>(24);
const multiplierOptions = computed(() => [
  {
    text: t("global.hours"),
    value: 1,
  },
  {
    text: t("global.days"),
    value: 24,
  },
]);

function getFilter() {
  return new RecentlyChangedFilter(numberOfHours.value * timeMultiplier.value);
}
function applyFilter(filter: RecentlyChangedFilter) {
  if (filter.definitionOfRecentInHours % 24 === 0) {
    timeMultiplier.value = 24;
    numberOfHours.value = filter.definitionOfRecentInHours / 24;
  } else {
    timeMultiplier.value = 1;
    numberOfHours.value = filter.definitionOfRecentInHours;
  }
}
defineExpose({
  getFilter,
  applyFilter,
});
</script>

<style lang="scss" scoped>
.border-fix {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
</style>
